var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from "react";
import { Money } from "@upserve/financials";
import { any, contains, equals, isEmpty, not } from "ramda";
import styled from "styled-components";
import MuiCheckbox from "components/mui_checkbox";
import MuiSelect from "components/mui_select";
import MuiTextfield from "components/mui_textfield";
import useViewportDimensions from "helpers/hooks/useViewportDimensions";
import Validators from "helpers/validation/validators";
import VALIDATION_MESSAGES from "helpers/validation/messages";
var StyledCardSubsection = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  margin-bottom: 32px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  grid-column-gap: 16px;\n  grid-template-areas:\n    \"header header\"\n    \"amount deliveryMethod\"\n    \"senderEmail senderEmail\"\n    \"senderPhone senderPhone\"\n    \"sendAsGift sendAsGift\";\n\n  .MuiFormControl-root,\n  h2 {\n    margin-bottom: 16px;\n  }\n"], ["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  margin-bottom: 32px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  grid-column-gap: 16px;\n  grid-template-areas:\n    \"header header\"\n    \"amount deliveryMethod\"\n    \"senderEmail senderEmail\"\n    \"senderPhone senderPhone\"\n    \"sendAsGift sendAsGift\";\n\n  .MuiFormControl-root,\n  h2 {\n    margin-bottom: 16px;\n  }\n"])));
var StyledDetailsSubsection = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n\n  .MuiFormControl-root,\n  h2 {\n    margin-bottom: 16px;\n  }\n"], ["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n\n  .MuiFormControl-root,\n  h2 {\n    margin-bottom: 16px;\n  }\n"])));
var StyledSubheader = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  grid-area: header;\n"], ["\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  grid-area: header;\n"])));
export var deliveryOptions;
(function (deliveryOptions) {
    deliveryOptions["EMAIL"] = "Email";
    deliveryOptions["SMS"] = "SMS";
})(deliveryOptions || (deliveryOptions = {}));
export default function OrderForm(_a) {
    var settings = _a.settings, setFormValid = _a.setFormValid, setFormValues = _a.setFormValues;
    var emailMaxChars = 200;
    var smsMaxChars = 160;
    var mobile = useViewportDimensions().mobile;
    var minValue = settings.minValue, maxValue = settings.maxValue;
    var emptyOrderInfo = {
        amount: "",
        deliveryMethodType: deliveryOptions.EMAIL,
        sendAsGift: false,
        message: "",
        recipientEmail: "",
        recipientName: "",
        recipientPhone: "",
        senderEmail: "",
        senderName: "",
        senderPhone: "",
        sendToSelf: false,
    };
    var defaultOrderInfoErrors = {
        amount: false,
        recipientEmail: false,
        recipientName: false,
        recipientPhone: false,
        senderEmail: false,
        senderName: false,
        senderPhone: false,
    };
    var _b = useState(emptyOrderInfo), orderInfo = _b[0], setOrderInfo = _b[1];
    var _c = useState(defaultOrderInfoErrors), orderInfoErrors = _c[0], setOrderInfoErrors = _c[1];
    var _d = useState(""), amountErrorMessage = _d[0], setAmountErrorMessage = _d[1];
    var updateOrderInfoProperty = function (key, val) {
        var _a;
        setOrderInfo(__assign(__assign({}, orderInfo), (_a = {}, _a[key] = val, _a)));
    };
    var onTextFieldUpdate = function (e) {
        var entry = e.target.value;
        if (contains(e.target.name, ["senderPhone", "recipientPhone"])) {
            entry = entry.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        }
        updateOrderInfoProperty(e.target.name, entry);
    };
    var onSelectUpdate = function (e) {
        updateOrderInfoProperty("deliveryMethodType", e.target.value);
    };
    var toggleSendAsGift = function () {
        setOrderInfo(__assign(__assign({}, orderInfo), { sendAsGift: !orderInfo.sendAsGift }));
    };
    var _e = useState(emailMaxChars), maxMessageChars = _e[0], setMaxMessageChars = _e[1];
    useEffect(function () {
        setMaxMessageChars(equals(deliveryOptions.EMAIL, orderInfo.deliveryMethodType)
            ? emailMaxChars - orderInfo.message.length
            : smsMaxChars - orderInfo.message.length);
    }, [orderInfo.message, orderInfo.deliveryMethodType]);
    var isValueEmptyOrError = function (name) {
        return isEmpty(orderInfo[name]) || orderInfoErrors[name];
    };
    var isValueInvalid = function (name) {
        switch (name) {
            case "senderPhone":
            case "recipientPhone":
                return (equals(deliveryOptions.SMS, orderInfo.deliveryMethodType) &&
                    isValueEmptyOrError(name));
            case "recipientEmail":
                return (equals(deliveryOptions.EMAIL, orderInfo.deliveryMethodType) &&
                    isValueEmptyOrError(name));
            default:
                return isValueEmptyOrError(name);
        }
    };
    useEffect(function () {
        var cardHasErrors = any(isValueInvalid, [
            "amount",
            "senderEmail",
            "senderPhone",
        ]);
        var detailHasErrors = equals(true, orderInfo.sendAsGift) &&
            any(isValueInvalid, [
                "senderName",
                "recipientName",
                "recipientPhone",
                "recipientEmail",
            ]);
        setFormValid(not(cardHasErrors || detailHasErrors));
    }, [orderInfoErrors, orderInfo.sendAsGift, orderInfo.deliveryMethodType]);
    useEffect(function () { return setFormValues(orderInfo); }, [orderInfo]);
    // name, email, and phone validators
    var validateField = function (e) {
        var _a, _b, _c;
        switch (e.target.name) {
            case "recipientEmail":
            case "senderEmail":
                setOrderInfoErrors(__assign(__assign({}, orderInfoErrors), (_a = {}, _a[e.target.name] = !Validators.isValidEmail(orderInfo[e.target.name]), _a)));
                break;
            case "recipientPhone":
            case "senderPhone":
                setOrderInfoErrors(__assign(__assign({}, orderInfoErrors), (_b = {}, _b[e.target.name] = !Validators.isValidPhoneNumber(orderInfo[e.target.name]), _b)));
                break;
            case "recipientName":
            case "senderName":
                setOrderInfoErrors(__assign(__assign({}, orderInfoErrors), (_c = {}, _c[e.target.name] = !Validators.isNotEmpty(orderInfo[e.target.name]), _c)));
                break;
            default:
        }
    };
    // amount-specific event handlers and validators
    var onAmountChange = function (amount) {
        var amountAsNumber = typeof amount === "string" ? parseFloat(amount) : amount;
        if (equals(NaN, amountAsNumber)) {
            setAmountErrorMessage("Gift card amount must be between " + minValue.format() + " and " + maxValue.format() + ".");
            updateOrderInfoProperty("amount", amount);
            return;
        }
        if (Money.fromDollars(amountAsNumber)) {
            if (Money.fromDollars(amountAsNumber).lt(minValue) ||
                maxValue.lt(Money.fromDollars(amountAsNumber))) {
                setAmountErrorMessage("Gift card amount must be between " + minValue.format() + " and " + maxValue.format() + ".");
            }
            else {
                setAmountErrorMessage("");
            }
        }
        else {
            setAmountErrorMessage("Gift card amount must be between " + minValue.format() + " and " + maxValue.format() + ".");
        }
        updateOrderInfoProperty("amount", amount);
    };
    var onAmountBlur = function (amount) {
        if (isEmpty(amount)) {
            setAmountErrorMessage("Gift card amount must be between " + minValue.format() + " and " + maxValue.format() + ".");
            return;
        }
        if (isEmpty(amountErrorMessage)) {
            var amountAsNumber = typeof amount === "string" ? parseFloat(amount) : amount;
            updateOrderInfoProperty("amount", amountAsNumber.toFixed(2).toString());
            setOrderInfoErrors(__assign(__assign({}, orderInfoErrors), { amount: false }));
            return;
        }
        setOrderInfoErrors(__assign(__assign({}, orderInfoErrors), { amount: true }));
    };
    var giftDetails = (React.createElement(StyledDetailsSubsection, null,
        React.createElement(StyledSubheader, null, "Gift Details"),
        React.createElement(MuiTextfield, { error: orderInfoErrors.senderName, errorMsg: orderInfoErrors.senderName
                ? VALIDATION_MESSAGES.isRequired("Sender")
                : null, label: "Sender Name", name: "senderName", onBlur: validateField, onChange: onTextFieldUpdate, required: true, value: orderInfo.senderName }),
        React.createElement(MuiTextfield, { error: orderInfoErrors.recipientName, errorMsg: orderInfoErrors.recipientName
                ? VALIDATION_MESSAGES.isRequired("Recipient")
                : null, label: "Recipient Name", name: "recipientName", onBlur: validateField, onChange: onTextFieldUpdate, required: true, value: orderInfo.recipientName }),
        equals(deliveryOptions.EMAIL, orderInfo.deliveryMethodType) && (React.createElement(MuiTextfield, { error: orderInfoErrors.recipientEmail, errorMsg: orderInfoErrors.recipientEmail ? VALIDATION_MESSAGES.email : null, label: "Recipient Email", name: "recipientEmail", onBlur: validateField, onChange: onTextFieldUpdate, required: true, value: orderInfo.recipientEmail })),
        equals(deliveryOptions.SMS, orderInfo.deliveryMethodType) && (React.createElement(MuiTextfield, { label: "Recipient Phone Number", name: "recipientPhone", value: orderInfo.recipientPhone, onChange: onTextFieldUpdate, onBlur: validateField, error: orderInfoErrors.recipientPhone, errorMsg: orderInfoErrors.recipientPhone ? VALIDATION_MESSAGES.phone : null, required: true })),
        React.createElement(MuiTextfield, { helperText: maxMessageChars + " characters left", label: "Message (optional)", maxLength: equals(deliveryOptions.SMS, orderInfo.deliveryMethodType)
                ? smsMaxChars
                : emailMaxChars, multiline: true, name: "message", onChange: onTextFieldUpdate, rows: 5, value: orderInfo.message })));
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledCardSubsection, null,
            React.createElement(StyledSubheader, null, "Gift Card"),
            React.createElement("div", { style: { gridArea: "amount" } },
                React.createElement(MuiTextfield, { errorMsg: amountErrorMessage, label: mobile ? "Amount" : "Gift Card Amount", name: "amount", onBlur: function (e) {
                        onAmountBlur(e.target.value);
                    }, onChange: function (e) { return onAmountChange(e.target.value); }, required: true, startAdornment: "$", value: orderInfo.amount })),
            React.createElement("div", { style: { gridArea: "deliveryMethod" } },
                React.createElement(MuiSelect, { label: "Delivery Method", menuItems: [
                        { value: deliveryOptions.EMAIL },
                        { value: deliveryOptions.SMS },
                    ], name: "deliveryMethod", onChange: onSelectUpdate, value: orderInfo.deliveryMethodType })),
            React.createElement("div", { style: { gridArea: "senderEmail" } },
                React.createElement(MuiTextfield, { error: orderInfoErrors.senderEmail, errorMsg: orderInfoErrors.senderEmail ? VALIDATION_MESSAGES.email : null, label: "Your Email", name: "senderEmail", onBlur: validateField, onChange: onTextFieldUpdate, required: true, value: orderInfo.senderEmail })),
            equals(deliveryOptions.SMS, orderInfo.deliveryMethodType) && (React.createElement("div", { style: { gridArea: "senderPhone" } },
                React.createElement(MuiTextfield, { error: orderInfoErrors.senderPhone, errorMsg: orderInfoErrors.senderPhone ? VALIDATION_MESSAGES.phone : null, label: "Phone Number", name: "senderPhone", onBlur: validateField, onChange: onTextFieldUpdate, required: true, value: orderInfo.senderPhone }))),
            React.createElement("div", { style: { gridArea: "sendAsGift" } },
                React.createElement(MuiCheckbox, { checked: orderInfo.sendAsGift, label: "Send as a gift", onChange: function () { return toggleSendAsGift(); } }))),
        orderInfo.sendAsGift && giftDetails));
}
var templateObject_1, templateObject_2, templateObject_3;
